// extracted by mini-css-extract-plugin
export default {"UpdateMinesProviderConfigContent":"UpdateMinesProviderConfigContent_UpdateMinesProviderConfigContent__IJ1Ys"};